<template>
  <div class="ranking">
    <div class="top">
      <p>排行榜</p>
      <p>排行数据每半个小时更新一次</p>
    </div>
    <div class="conter">
      <ul>
        <li>名次</li>
        <li>用户昵称</li>
        <li>分数</li>
        <li>耗时</li>
      </ul>
      <van-list
        v-model:loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :offset="500"
      >
        <van-cell v-for="(item, index) in list" :key="index" class="list">
          <ul>
            <li>
              <img
                :src="
                  index == 0
                    ? require('../../assets/stormPassAnswer/one.png')
                    : index == 1
                    ? require('../../assets/stormPassAnswer/two.png')
                    : index == 2
                    ? require('../../assets/stormPassAnswer/three.png')
                    : ''
                "
                alt
              />
              <span v-if="index > 2">{{ index + 1 }}</span>
            </li>
            <li>
              <van-image :src="item.imgpath">
                <template v-slot:error>
                  <img :src="defaultImg" alt />
                </template>
              </van-image>
              <span>{{ item.webUserName }}</span>
            </li>
            <li>{{ item.webScore }}</li>
            <li>{{ item.webPasstime }}秒</li>
          </ul>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>

<script>
import { getBreakthroughRank } from "@/api/stormPassAnswer";
import { filePerviewPath } from "@/api/ActivitySolicitation/index.js";
export default {
  data() {
    return {
      loading: true, //下来加载
      finished: false,
      list: [],
      pageNum: 0,
      defaultImg: require("../../assets/img/portrait.png")
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    //下拉加载
    onLoad() {
      ++this.pageNum;
      this.getList();
    },
    getList() {
      getBreakthroughRank({
        pageNum: this.pageNum,
        webBreakthroughId: this.$route.query.id
      }).then(({ data }) => {
        if (data.code == 200) {
          if (data.data.list.length > 0) {
            this.loading = false;
            this.list = [...this.list, ...data.data.list];
            this.list.map(ele => {
              ele.imgpath = filePerviewPath({
                id: ele.webUserAvatar,
                type: "cover"
              });
            });
          } else {
            this.finished = true;
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.van-image {
  width: 0.8rem !important;
  height: 0.8rem !important;
  border-radius: 50% !important;
  margin-right: 0.24rem !important;
  overflow: hidden;
}
.ranking {
  .top {
    background: url("../../assets/stormPassAnswer/ranking.png") no-repeat;
    background-size: 100%;
    height: 4.08rem;
    padding: 0.8rem 0 1.76rem 0.72rem;
    box-sizing: border-box;
    color: #fff;
    > p:first-child {
      font-weight: 500;
      font-size: 0.76rem;
    }
    > p:last-child {
      font-size: 0.28rem;
      margin-top: 0.08rem;
    }
  }
  .conter {
    margin-top: -0.96rem;
    ul {
      display: flex;
      font-size: 0.28rem;
      color: #999999;
      border-radius: 0.32rem 0.32rem 0px 0px;
      background: #fff;
      justify-content: space-between;
      line-height: 0.96rem;
      > li {
        text-align: center;
      }
      li:first-child {
        width: 15%;
        img {
          vertical-align: middle;
        }
      }
      li:nth-child(3),
      li:nth-child(4) {
        width: 20%;
      }
      li:nth-child(2) {
        width: 45%;
        text-align: left;
        display: flex;
        align-items: center;
        // > img {
        //   width: 0.8rem;
        //   height: 0.8rem;
        //   border-radius: 50%;
        //   margin-right: 0.24rem;
        // }

        > span {
          width: 67%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .list {
      padding: 0 !important;

      li {
        line-height: 1.52rem;
      }
    }
    .list::after {
      border: none !important;
    }
  }
}
</style>